import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';
import {
    IMediaItemAlignmentMenuItem,
    MediaItemAlignmentMenuItemAlignmentType,
    FiTextItemMediaPanelAlignmentMenuItems,
} from '@fi-app/utilities/insert-media/fi-text-item-media-panel-handler/fi-text-item-media-panel-alignment/fi-text-item-media-panel-alignment-menu-items';
import { FiTextItemMediaPanelItemBaseComponent } from '@fi-app/utilities/insert-media/fi-text-item-media-panel-handler/fi-text-item-media-panel-item-base/fi-text-item-media-panel-item-base.component';

@Component({
    selector: 'fi-text-item-media-panel-alignment',
    template: `
        <button
            mat-icon-button
            class="fi-text-item-media-panel-action"
            [matMenuTriggerFor]="menu"
            (menuOpened)="toggleMenuBrandedClass(true)"
            (menuClosed)="toggleMenuBrandedClass(false)"
        >
            <mat-icon><span class="fa" [ngClass]="getPanelActionAlignmentIcon()"></span></mat-icon>
        </button>

        <mat-menu #menu="matMenu" class="mat-menu-alignment">
            @for (menuItem of mediaItemAlignmentMenuItems; track menuItem) {
                <button
                    mat-menu-item
                    class="fi-text-item-media-panel-menu-item fi-text-item-media-alignment-menu "
                    (click)="menuItemClick(menuItem.alignmentType, menuItem.mediaItemClass, $event)"
                >
                    <span class="menu-item-label">{{ menuItem.label | fiAppText }}</span>
                    <mat-icon>
                        @if (isAlignmentSelected(menuItem.alignmentType)) {
                            <span class="fas fa-check BrandedColor"></span>
                        }
                    </mat-icon>
                </button>
            }
        </mat-menu>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-menu-item-alignment' },
    standalone: false,
})
export class FiTextItemMediaPanelAlignmentComponent extends FiTextItemMediaPanelItemBaseComponent implements OnChanges {
    @Input() currentItemMediaAlignmentClass: string;
    @Output() setAlignmentClass = new EventEmitter<string>();
    mediaItemAlignmentMenuItems: IMediaItemAlignmentMenuItem[] = FiTextItemMediaPanelAlignmentMenuItems;
    currentAlignmentType: number;

    ngOnChanges(changes: SimpleChanges) {
        if (
            changes.hasOwnProperty('currentItemMediaAlignmentClass') &&
            changes.currentItemMediaAlignmentClass.currentValue
        ) {
            this.setCurrentAlignmentType();
        }
    }

    private setCurrentAlignmentType(): void {
        const alignmentMenuItem = this.mediaItemAlignmentMenuItems.find(
            (alignmentItem: IMediaItemAlignmentMenuItem) => {
                return alignmentItem.mediaItemClass === this.currentItemMediaAlignmentClass;
            },
        );
        this.currentAlignmentType = alignmentMenuItem
            ? alignmentMenuItem.alignmentType
            : MediaItemAlignmentMenuItemAlignmentType.Center;
    }

    menuItemClick(alignmentType: number, mediaItemClass: string, $event: MouseEvent): void {
        $event.stopPropagation();
        this.setAlignmentClass.emit(mediaItemClass);
        this.currentAlignmentType = alignmentType;
        this.toggleMenu();
    }

    isAlignmentSelected(alignmentType: number): boolean {
        return this.currentAlignmentType === alignmentType;
    }

    isAlignmentCenter(): boolean {
        return this.currentAlignmentType === MediaItemAlignmentMenuItemAlignmentType.Center;
    }

    isAlignmentLeft(): boolean {
        return this.currentAlignmentType === MediaItemAlignmentMenuItemAlignmentType.Left;
    }

    isAlignmentRight(): boolean {
        return this.currentAlignmentType === MediaItemAlignmentMenuItemAlignmentType.Right;
    }

    getPanelActionAlignmentIcon() {
        return {
            BrandedColor: this.isMenuOpened,
            'fa-align-center': this.isAlignmentCenter(),
            'fa-align-left': this.isAlignmentLeft(),
            'fa-align-right': this.isAlignmentRight(),
        };
    }
}
